export { HousingCardGallerySwiper } from './HousingCardGallerySwiper';
